import { render, staticRenderFns } from "./chart-of-account.vue?vue&type=template&id=69bdd60c"
import script from "./chart-of-account.vue?vue&type=script&lang=js"
export * from "./chart-of-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports